import { sendEventToMixpanel } from '@infrastructure/Mixpanel'

export const sendQuoteCategoryFormShown = () => {
    sendEventToMixpanel({
        eventName: 'QuoteCategoryFormShown',
    })
}
